require("./p3.scss");

const {parallax,scrollElement} = require("../scrollAnimation");

(function($){

    $(document).ready(function(){
        // parallax($(".title"),0,0);
        // parallax($("#sec18"),0,0);
        // parallax($("#sec22"),0,0);

        scrollElement($("#sec18 .col:first-of-type"),null,'left-to-right',0);
        scrollElement($("#sec18 .col:last-of-type"),null,'right-to-left',0);

        scrollElement($("#sec22"),'ul li:nth-child(1)','bottom-to-top',0);
        scrollElement($("#sec22"),'ul li:nth-child(2)','bottom-to-top',0.2);
        scrollElement($("#sec22"),'ul li:nth-child(3)','bottom-to-top',0.4);
        scrollElement($("#sec22"),'ul li:nth-child(4)','bottom-to-top',0.6);
        scrollElement($("#sec22"),'ul li:nth-child(5)','bottom-to-top',0.8);
        scrollElement($("#sec22"),'ul li:nth-child(6)','bottom-to-top',1);

    });

})(jQuery)